// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__sCHsx","skeletonBase":"styles_skeletonBase__3wAU0"};